<div *ngIf="isActive" class="ig-calendar modern-block h-full">
  <div *ngIf="isShowMoreSearchOptions" class="ig-search-more">
    <div class="ig-search-more-wrap">
      <p>Can't find what you're looking for? Click
        <span #searchMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="searchOptionsMenu"
          class="underline cursor-pointer text-blue-400 font-semibold">HERE</span>
        to explore more options.
      </p>

      <mat-menu #searchOptionsMenu="matMenu" class="ig-search-options-menu" igClickStopPropagation>
        <div class="p-4" igClickStopPropagation>
          <div class="flex flex-col gap-2" igClickStopPropagation>
            <b>Search From</b>
            <div *ngFor="let option of ['name', 'address', 'category', 'description']" igClickStopPropagation>
              <mat-checkbox [(ngModel)]="searchOptions[option]" igClickStopPropagation>
                {{ option | titlecase }}
              </mat-checkbox>
            </div>
            <button mat-raised-button color="primary" [disabled]="!hasSelectedOptions"
              (click)="applySearchOptions(searchMenuTrigger)" class="mt-3">
              SEARCH MORE
            </button>
          </div>
        </div>
      </mat-menu>
    </div>
  </div>

  <ig-infinite-scroll-container [loadMore]="loadItems" mode="normal" [isEvent]="actionCommand.isEventCalendar"
    [searchFields]="searchFields"></ig-infinite-scroll-container>
  <div></div>
</div>

<div *ngIf="!isActive" class="w-full h-full flex justify-center items-center text-xl">
  This feature is disabled, please contact our team, emailing aline&#64;iti-digital.com or call us at 912-267-1558
</div>